var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"admin-data-header"},[_c('app-admin-data-report-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }